/* istanbul ignore next */
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export const pageview = (url: string) => {
  /* istanbul ignore next */
  if (typeof globalThis.window === 'undefined') return;

  globalThis.window.dataLayer = globalThis.window.dataLayer || [];

  globalThis.window.dataLayer.push({
    event: 'page_view',
    page_path: url,
  });
};

export const setUserId = (userId: string) => {
  /* istanbul ignore next */
  if (typeof globalThis.window === 'undefined') return;

  globalThis.window.dataLayer = globalThis.window.dataLayer || [];

  globalThis.window.dataLayer.push({
    event: 'set_user_id',
    user_id: userId,
  });
};

export const trackEvent = (action: string, params: Record<string, unknown> = {}) => {
  /* istanbul ignore next */
  if (typeof globalThis.window === 'undefined') return;
  // Only push to dataLayer if GTM_ID is configured
  if (!GTM_ID) return;

  const eventName = `clone_${action}`;
  globalThis.window.dataLayer = globalThis.window.dataLayer || [];
  globalThis.window.dataLayer.push({
    event: eventName,
    ...params,
  });
};
